import React, { useState, useRef, useEffect } from "react";
import {
    TextField,
    Grid,
    InputLabel,
    FormControl,
    Select,
    MenuItem,
    FormControlLabel,
    Checkbox,
    TextareaAutosize,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    debounce,
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import Modal from "react-bootstrap/Modal";
import CloseIcon from "@mui/icons-material/Close";
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import ItemMasterHelp from "../../../Helper/SystemmasterHelp";
import SystemHelpMaster from "../../../Helper/SystemmasterHelp";
import BrandMasterHelp from "../../../Helper/BrandMasterHelp";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import ActionButtonGroup from "../../../Common/CommonButtons/ActionButtonGroup";
import NavigationButtons from "../../../Common/CommonButtons/NavigationButtons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../..";
import AddButton from "../../../Common/Buttons/AddButton";
import EditButton from "../../../Common/Buttons/EditButton";
import DeleteButton from "../../../Common/Buttons/DeleteButton";
import OpenButton from "../../../Common/Buttons/OpenButton";
import UserAuditInfo from "../../../Common/UserAuditInfo/UserAuditInfo";
import SaveUpdateSpinner from "../../../Common/Spinners/SaveUpdateSpinner";
import Swal from "sweetalert2";
import DetailAddButtom from "../../../Common/Buttons/DetailAddButton";
import DetailCloseButton from "../../../Common/Buttons/DetailCloseButton";
import DetailUpdateButton from "../../../Common/Buttons/DetailUpdateButton";
import { OutwordPostDateRecordLock } from "../../../Common/PostDateLock/PostDateRangeCheck";
import { validateDocumentDate } from "../../../Common/ValidateDateRange/ValidateDateRange";
import formatTruckNumber from "../../../Common/FormatFunctions/FormatTruckNumber";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import { Update } from "@mui/icons-material";
import PattiReport from "./PattiEntryReport";
import AwakEntryhelp from "../../../Helper/PattiAwakEntryHelp";
import PattiBatchPrintReport from "./PattiEntryBatchReport";


// Common style for all table headers

//Global Variables
var newAwakid = "";
var partyName = "";
var partyCode = "";
var newId = "";
var itemName = "";
var item_code = "";
var gstrate = "";
var gstRateCode = "";
var gstName = "";
var brandName = "";
var brandCode = "";
var transportName = "";
var transportCode = "";
var billToName = "";
var billToCode = "";
var selectedfilter = "";
var PartyMobNo = "";
var TransportMobNo = "";
var UnitMobNo = "";
var millgstno = "";
var Advance_No = "";
var AwakNo = "";
var AdvanceDate = "";
var Amount = "";
var Advance_Type = "";
var pattiAmount = "";

const headerCellStyle = {
    fontWeight: "bold",
    backgroundColor: "#3f51b5",
    color: "white",
    padding: "6px",
    textAlign: "center",
    "&:hover": {
        backgroundColor: "#303f9f",
        cursor: "pointer",
    },
};

//API URL
const API_URL = process.env.REACT_APP_API;

const PattiEntry = () => {
    const companyCode = sessionStorage.getItem("Company_Code");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const username = sessionStorage.getItem("username");
    const TCSApplicable = sessionStorage.getItem("TCSApplicable");
    const User_Id = sessionStorage.getItem("User_ID");

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigatedRecord = searchParams.get("navigatedRecord");
    const permissions = location.state?.permissionsData;

    //State Management
    const [users, setUsers] = useState([]);
    const [advances, setAdvances] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMode, setPopupMode] = useState("add");
    const [showPopupForAdvance, setShowPopupForAdvance] = useState(false);
    const [popupAdvanceMode, setPopupAdvanceMode] = useState("add");
    const [selectedUser, setSelectedUser] = useState({});
    const [selectedAdvanceUser, setSelectedAdvanceUser] = useState({});
    const [deleteMode, setDeleteMode] = useState(false);
    const [deleteModeAdvance, setDeleteModeAdvance] = useState(false);
    const [itemCode, setItemCode] = useState("");
    const [item_Name, setItemName] = useState("");
    const [itemCodeAccoid, setItemCodeAccoid] = useState("");
    const [formDataDetail, setFormDataDetail] = useState({
        bill_no: 0,
        bill_Date: new Date().toISOString().split("T")[0],
        Qty: 0.0,
        wt: 0.0,
        Netwt: 0.0,
        Value: 0.0,
        ic: "",
        Packing: 0.0,
        netamt: 0.0,
        container: 0.0,
        PId: 0,
        gulsalebilldetailId: 0,
        gulsalebill: 0,
        AwakNo: 0,
        AwakDetailId: 0,
        Kattapatti: 0,
        tolaidar: "",
        Tran_Type: "PT",
        detail_id: 1,
    });

    const [formDataAdvance, setFormDataAdvance] = useState({

        Advance_No: "",
        AdvanceDate: new Date().toISOString().split("T")[0],
        Advance_Type: 'A',
        Amount: 0.0,
        PId: 0,
        AdvanceId: 0,
        Company_Code: companyCode,
        Year_Code: Year_Code,
        AwakNo: 0,
        advance_id: 1,
    });

    //Head Section State Managements
    const [addOneButtonEnabled, setAddOneButtonEnabled] = useState(false);
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(true);
    const [cancelButtonEnabled, setCancelButtonEnabled] = useState(true);
    const [editButtonEnabled, setEditButtonEnabled] = useState(false);
    const [deleteButtonEnabled, setDeleteButtonEnabled] = useState(false);
    const [backButtonEnabled, setBackButtonEnabled] = useState(true);
    const [Patti_Awak_AdvanceData, setPatti_Awak_AdvanceData] = useState([]);

    const [isEditMode, setIsEditMode] = useState(false);
    const [highlightedButton, setHighlightedButton] = useState(null);
    const [cancelButtonClicked, setCancelButtonClicked] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [lastTenderDetails, setLastTenderDetails] = useState([]);
    const [lastTenderData, setLastTenderData] = useState({});
    const [lastAdvanceData, setLastAdvanceData] = useState([]);
    const [formErrors, setFormErrors] = useState({});
    const [isChecked, setIsChecked] = useState(false);
    const [gstNo, setGstNo] = useState("");
    const [isHandleChange, setIsHandleChange] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenEInvoice, setIsOpenEInvoice] = useState(false);
    const [isOpenEwayBill, setIsOpenEwayBill] = useState(false);
    const [billToManuallySet, setBillToManuallySet] = useState(false);
    const [shipToManuallySet, setShipToManuallySet] = useState(false);
    const [bill_To_Name, setBillToName] = useState("");
    const [ship_To_Name, setShipToName] = useState("");
    const [advanceData, setAdvanceData] = useState([]);

    const [AwakId, setAwakId] = useState("");
    const [awakChanged, setAwakChanged] = useState(false);
    const [Awakcode, setAwakCode] = useState("");

    const [awakDetailRows, setAwakDetailRows] = useState([]);
    const [awakAdvanceRows, setAwakAdvanceRows] = useState([]);
    const [showAdvancePopup, setShowAdvancePopup] = useState(false);
    const [tempAdvanceData, setTempAdvanceData] = useState(null);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [appliedAwakNos, setAppliedAwakNos] = useState([]);
    const [prevSelectedDocNos, setPrevSelectedDocNos] = useState([]);
    const [appliedAwakData, setAppliedAwakData] = useState([]);

    const [resetPattiSelection, setResetPattiSelection] = useState(false);

    const selectedRecord = location.state?.selectedRecord;
    const navigate = useNavigate();
    const inputRef = useRef(null);

    console.log(selectedRecord)

    //SET Focus to the ADD Buttons.
    const addButtonRef = useRef(null);
    const firstInputRef = useRef(null);
    const setFocusToFirstField = () => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    };

    //Initial Formdata

    const initialFormData = {
        Doc_No: "",
        Doc_Date: new Date().toISOString().split("T")[0],
        Company_Code: companyCode,
        Year_Code: Year_Code,
        Ac_Code: "",
        ac: 0,
        CustomerCode: "" || 0,
        cc: 0,
        Created_By: "",
        Modified_By: "",
        Hamaliamt: 0.0,
        Tolai: 0.0,
        netexps: 0.0,
        Advances: 0.0,
        Patti_Amount: 0.0,
        netQty: 0.0,
        netwt: 0.0,
        netAmt: 0.0,
        netpacking: 0.0,
        Container: 0.0,
        AwakDate: "",

    };

    //ALL Help Section State managements
    const [formData, setFormData] = useState(initialFormData);
    const [billFrom, setBillFrom] = useState("");
    const [partyMobNo, setPartyMobNo] = useState("");
    const [billTo, setBillTo] = useState("");
    const [mill, setMill] = useState("");
    const [millname, setMillName] = useState("");
    const [millGSTNo, setMillGSTNo] = useState("");
    const [shipTo, setShipTo] = useState("");
    const [shipToMobNo, setShipToMobNo] = useState("");
    const [gstCode, setGstCode] = useState("");
    const [transport, setTransport] = useState("");
    const [transportMob, setTransportMob] = useState("");
    const [broker, setBroker] = useState("");
    const [framer, setFramer] = useState("");
    const [GstRate, setGstRate] = useState(0.0);
    const [matchStatus, setMatchStatus] = useState(null);
    const [TolaiSaleRate, setTolaiSaleRateforPatti] = useState('N');

    //Validation Input feilds
    const validateNumericInput = (e) => {
        e.target.value = e.target.value.replace(/[^0-9.-]/g, "");
    };

    const formatTruckNumber = (value) => {
        const cleanedValue = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        return cleanedValue.length <= 10 ? cleanedValue : cleanedValue.substring(0, 10);
    };

    //Handle Records OnChange Method
    const handleChange = (event) => {
        const { name, value } = event.target;
        const updatedValue = name === "Truck_No" ? formatTruckNumber(value) : value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));
    };


    const checkAdvanceUsage = async (Advance_No) => {
        try {
            const res = await axios.get(`${API_URL}/check-Advance-usage`, {
                params: {
                    Doc_No: Advance_No,
                    Company_Code: companyCode,
                    // Year_Code: Year_Code, // Uncomment if needed
                },
            });

            return res.data?.isUsed ?? false; // Always return a boolean
        } catch (err) {
            console.error("Error checking Proforma usage:", err);
            return false; // Fail-safe
        }
    };

    const checkGulSalebillForDetailIdUsage = async (awakdetailId) => {
        try {
            const res = await axios.get(`${API_URL}/check-salebilldetailId-usage`, {
                params: {
                    Id: awakdetailId,
                    Company_Code: companyCode,
                    Year_Code: Year_Code,
                },
            });

            return res.data?.isUsed ?? false; // Always return a boolean
        } catch (err) {
            console.error("Error checking Proforma usage:", err);
            return false; // Fail-safe
        }
    };



    //handle the Date OnChange Values
    const handleDateChange = (event, fieldName) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldName]: event.target.value,
        }));
    };

    useEffect(() => {
        if (isHandleChange) {
            handleCancel();
            setIsHandleChange(false);
        }
    }, []);


    const [paramsLoaded, setParamsLoaded] = useState(false);

    const fetchHamaliSaleRate = async (company_code, year_code) => {
        try {
            const { data } = await axios.get(`${API_URL}/get-CompanyParameters-Record`, {
                params: { Company_Code: company_code, Year_Code: year_code },
            });
            const rate = (data?.CompanyParameters_data?.TolaiSaleRateforPatti || '')
                .toString().trim().toUpperCase();
            setTolaiSaleRateforPatti(rate);
        } catch (error) {
            console.error("Error fetching TolaiSaleRateforPatti:", error);
            setTolaiSaleRateforPatti('N');
        } finally {
            setParamsLoaded(true);
        }
    };


    useEffect(() => {
        if (companyCode && Year_Code) {
            fetchHamaliSaleRate(companyCode, Year_Code);
        }
    }, [companyCode, Year_Code]);

    //fetchLast Records to get the next doc no
    const fetchLastRecord = () => {
        fetch(
            `${API_URL}/get-next-doc-no-forPattiEntry?Company_Code=${companyCode}&Year_Code=${Year_Code}`
        )
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch last record");
                }
                return response.json();
            })
            .then((data) => {
                const newDocNo = data.next_doc_no;
                setFormData((prevState) => ({
                    ...prevState,
                    Doc_No: newDocNo,
                }));
            })
            .catch((error) => {
                console.error("Error fetching last record:", error);
            });
    };



    const getEffectiveTolaiRate = (detail) => {
        if (!detail) return 0;
        const rate = TolaiSaleRate === 'Y'
            ? detail.TolaiSale_rate
            : detail.Tolai_rate;
        return parseFloat(rate) || 0;
    };
    //handle record Add.
    const handleAddOne = async () => {

        setAddOneButtonEnabled(false);
        setSaveButtonEnabled(true);
        setCancelButtonEnabled(true);
        setEditButtonEnabled(false);
        setDeleteButtonEnabled(false);
        setIsEditMode(false);
        setIsEditing(true);
        fetchLastRecord();
        setFormData(initialFormData);
        setFormDataAdvance(formDataAdvance);
        partyName = "";
        partyCode = "";
        itemName = "";
        item_code = "";
        newId = "";
        Advance_No = "";
        Amount = "";
        Advance_Type = "";
        setFramer("");

        setLastTenderDetails([]);
        setLastAdvanceData([]);
        // setPatti_Awak_AdvanceData([]);
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };

    //handle Edit record functionality.
    const handleEdit = async () => {

        const Post_Date = sessionStorage.getItem("Post_Date");
        const Outword_Date = sessionStorage.getItem("Outword_Date")

        if (await OutwordPostDateRecordLock(formData.Doc_Date, Post_Date, Outword_Date)) {
            return;
        }

        // if (
        //   (formData.einvoiceno && formData.einvoiceno.trim() !== "" && formData.ackno && formData.ackno.trim() !== "") ||
        //   (formData.EWay_Bill_No && formData.EWay_Bill_No.trim() !== "")
        // ) {
        let message = "";

        //   if (formData.einvoiceno && formData.einvoiceno.trim() !== "" && formData.ackno && formData.ackno.trim() !== "") {
        //     message += "E-Invoice has already been generated for this record.";
        //   }

        //   if (formData.EWay_Bill_No && formData.EWay_Bill_No.trim() !== "") {
        //     message += (message ? "\n" : "") + "E-WayBill has already been generated for this record.";
        //   }

        Swal.fire({
            icon: "warning",
            text: message,
            confirmButtonColor: "#d33",
        });

        if (!formData?.Id) {
            console.error(
                "❌ Cannot edit: formData.Id is missing or invalid",
                formData
            );
            Swal.fire({
                icon: "error",
                title: "Invalid Record",
                text: "The selected record is missing an ID.",
            });
            return;
        }

        console.log(" Sending Id:", formData.Id); // should not be undefined or empty

        axios
            .get(
                `${API_URL}/PattiEntryByid?Id=${formData.Id}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
            )
            .then((response) => {
                const data = response.data;
                // const isLockedNew = data.last_head_data.LockedRecord;
                // const isLockedByUserNew = data.last_head_data.LockedUser;

                // if (isLockedNew) {
                //   Swal.fire({
                //     icon: "warning",
                //     title: "Record Locked",
                //     text: `This record is locked by ${isLockedByUserNew}`,
                //     confirmButtonColor: "#d33",
                //   });
                //   return
                // }
                // else {
                //   lockRecord();
                // }
                setFormData({
                    ...formData,
                    ...data.last_head_data,
                });
                setIsEditMode(true);
                setAddOneButtonEnabled(false);
                setSaveButtonEnabled(true);
                setCancelButtonEnabled(true);
                setEditButtonEnabled(false);
                setDeleteButtonEnabled(false);
                setBackButtonEnabled(true);
                setIsEditing(true);
            })
            .catch((error) => {
                // window.alert("This record is already deleted! Showing the previous record.");
            });
    };

    // Record save and update functionality
    const handleSaveOrUpdate = async () => {
        if (
            await OutwordPostDateRecordLock(
                formData.Doc_Date,
                // Post_Date,
                // Outword_Date
            )
        ) {
            return;
        }

        const accountingYearData = sessionStorage.getItem("Accounting_Year");
        const formattedEntryDate = formData.Doc_Date;
        const isValid = validateDocumentDate(
            formattedEntryDate,
            accountingYearData
        );

        if (!isValid) {
            return;
        }

        if (
            users.length === 0 ||
            users.every(
                (user) => user.rowaction === "DNU" || user.rowaction === "delete"
            )
        ) {
            Swal.fire({
                text: "Please add at least one entry in the detail grid.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        setIsEditing(true);
        setIsLoading(true);

        let headData = {
            ...formData,
            //   GstRateCode: gstCode || gstRateCode,
            //   RateDiff: formData.RateDiff || 0,
            ...(isEditMode
                ? {
                    Modified_By: username,
                    // User_Id: User_Id,
                }
                : {
                    Created_By: username,
                }),
        };



        delete headData[""];
        // delete headData.RateDiffAmount;
        if (isEditMode) {
            delete headData.Id;
            headData.Modified_By = username
            // headData.User_Id = User_Id
        } else {
            headData.Created_By = username;
        }
        const detailData = users.map((user) => ({
            rowaction: user.rowaction,
            PattidetailId: user.PattidetailId,
            detail_id: user.detail_id,
            Item_Code: user.Item_Code,
            Qty: user.Qty,
            Netwt: user.Netwt,
            Value: user.Value,
            Packing: user.Packing,
            container: user.container,
            ic: user.ic,
            netamt: user.netamt,
            AwakNo: user.AwakNo,
            AwakDetailId: user.AwakDetailId,
            gulsalebill: user.gulsalebill,
            gulsalebilldetailId: user.gulsalebilldetailId,
            CustomerCode: user.CustomerCode,
            cc: user.cc,
            bill_no: user.bill_no,
            bill_Date: user.bill_Date,
            tolaidar: user.tolaidar,
            Kattapatti: user.Kattapatti,
            Created_By: username,
            Modified_By: username,
            Company_Code: companyCode,
            Year_Code: Year_Code,

        }));

        const AdvanceData = advances.map((advance) => {
            const isNew = !advance.advance_id;
            return {
                rowaction: isNew ? "add" : advance.rowaction || "Normal",
                PattiadvId: advance.PattiadvId,
                advance_id: advance.advance_id,
                Advance_No: advance.Advance_No,
                Advance_Type: advance.Advance_Type,
                AdvanceDate: advance.AdvanceDate,
                Amount: advance.Amount,
                AdvanceId: advance.AdvanceId,
                advance_id: isNew
                    ? (Math.max(...advances.map((u) => u.advance_id || 0)) || 0) + 1
                    : advance.advance_id,
                Company_Code: companyCode,
                Year_Code: Year_Code,
                Created_By: username,
                AwakNo: advance.AwakNo,
            }

        });

        const requestData = {
            headData,
            detailData,
            AdvanceData,
        };

        try {
            if (isEditMode) {
                const updateApiUrl = `${API_URL}/Update_AwakEntry?Id=${newId}`;
                console.log("newId", newId)
                const response = await axios.put(updateApiUrl, requestData);
                const savedDocNo = response.data?.Doc_No || formData.Doc_No;

                // unlockRecord();
                Swal.fire({
                    title: "Success!",
                    text: "Record updated successfully!",
                    icon: "success",
                    confirmButtonText: "OK",
                });

                setTimeout(() => {
                    window.onbeforeunload = null;
                    window.location.reload();
                }, 1000);
                navigate(`/PattiEntry-api?navigatedRecord=${savedDocNo}`);
            } else {
                const response = await axios.post(
                    `${API_URL}/insert_Pattientry_head_detail`,
                    requestData
                );
                const savedDocNo = response.data?.Doc_No || formData.Doc_No;
                Swal.fire({
                    title: "Success!",
                    text: "Record saved successfully!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
                setIsEditMode(false);
                setAddOneButtonEnabled(true);
                setEditButtonEnabled(false);
                setDeleteButtonEnabled(true);
                setBackButtonEnabled(true);
                setSaveButtonEnabled(false);
                setCancelButtonEnabled(false);
                setIsEditing(true);

                setTimeout(() => {
                    window.location.reload();
                }, 1000);
                navigate(`/PattiEntry-api?navigatedRecord=${savedDocNo}`);
            }
        } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Error occurred while saving data");
        } finally {
            setIsEditing(false);
            setIsLoading(false);
        }
    };

    const handleDelete = async () => {
        try {

            // const isUsed = await checkGulSalebillUsage(formData.Doc_No);

            // if (isUsed) {
            //     Swal.fire({
            //         icon: "error",
            //         title: "Cannot Delete",
            //         text: "This Doc No is already used in Gul Sale Bill. You cannot delete it.",
            //         confirmButtonColor: "#d33",
            //     });
            //     return;
            // }




            // if (
            //   await OutwordPostDateRecordLock(
            //     formData.doc_date,
            //     // Post_Date,
            //     // Outword_Date
            //   )
            // ) {
            //   return;
            // }

            // if (parseInt(formData.doc_no) !== 0) {
            //   Swal.fire({
            //     title: "Error",
            //     text: `Couldn't delete this record it is currently referenced in DO No. ${formData.DO_No}`.trim(),
            //     icon: "error",
            //     confirmButtonText: "OK",
            //   });
            //   return;
            // }

            // if (parseInt(formData.einvoiceno) !== "" && formData.ackno !== "") {
            //   Swal.fire({
            //     icon: "warning",
            //     text: "E-Invoice has already been generated for this record.Cannot Delete.",
            //     confirmButtonColor: "#d33",
            //   });
            //   return;
            // }

            // if (formData.EWay_Bill_No !== "") {
            //   Swal.fire({
            //     icon: "warning",
            //     text: "E-WayBill has already been generated for this record.Cannot Delete.",
            //     confirmButtonColor: "#d33",
            //   });
            //   return;
            // }

            // try {

            const response = await axios.get(
                `${API_URL}/PattiEntryByid?Id=${newId}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );

            const data = response.data;
            // const isLockedNew = data.last_head_data.LockedRecord;
            // const isLockedByUserNew = data.last_head_data.LockedUser;

            // if (isLockedNew) {
            //   Swal.fire({
            //     title: "Record Locked",
            //     text: `This record is locked by ${isLockedByUserNew}`,
            //     icon: "warning",
            //     confirmButtonText: "OK",
            //   });
            //   return;
            // }

            const result = await Swal.fire({
                title: "Are you sure?",
                text: `Do you really want to delete this Doc No: ${formData.Doc_No}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                cancelButtonText: "Cancel",
                confirmButtonText: "Delete",
                reverseButtons: true,
                focusCancel: true,
            });

            if (result.isConfirmed) {
                setIsEditMode(false);
                setAddOneButtonEnabled(true);
                setEditButtonEnabled(false);
                setDeleteButtonEnabled(true);
                setBackButtonEnabled(true);
                setSaveButtonEnabled(false);
                setCancelButtonEnabled(false);
                setIsLoading(true);

                const deleteApiUrl = `${API_URL}/delete_data_by_Pattientryid?Id=${newId}&PId=${newId}&Company_Code=${companyCode}&Year_Code=${Year_Code}&Doc_No=${formData.Doc_No}`;
                const deleteResponse = await axios.delete(deleteApiUrl);

                if (deleteResponse.status === 200) {
                    if (deleteResponse.data) {
                        Swal.fire({
                            title: "Deleted!",
                            text: "Data deleted successfully!",
                            icon: "success",
                            confirmButtonText: "OK",
                        });
                        const docNoNum = parseInt(formData.Doc_No);
                        if (!docNoNum || docNoNum <= 1) {
                            handleAddOne();
                        } else {

                            handleCancel();
                        }
                    }
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "Failed to delete the record.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            } else {
                Swal.fire({
                    title: "Cancelled",
                    text: "Your record is safe 🙂",
                    icon: "info",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            console.error("Error during API call:", error);
            Swal.fire({
                title: "Error",
                text: `There was an error during the deletion: ${error.message}`,
                icon: "error",
                confirmButtonText: "OK",
            });
        } finally {
            setIsLoading(false);
        }
    };


    const NavigationSetFields = (headData, detailData, AdvanceData) => {
        const details = (Array.isArray(detailData) && detailData.length > 0) ? detailData[0] : {};
        const advance = (Array.isArray(AdvanceData) && AdvanceData.length > 0) ? AdvanceData[0] : {};
        console.log("NavigationSetFieldsdetails", details)
        newId = headData?.Id || "";
        partyName = details?.PattiAccName || "";
        partyCode = headData?.Ac_Code || "";
        billToCode = headData?.Bill_To || "";
        itemName = details?.System_Name_E || "";
        item_code = details?.System_Code || "";
        Advance_No = advance?.Advance_No || "";
        AwakNo = advance?.AdvanceawakNo || "";
        AdvanceDate = advance?.advdate || advance?.AdvanceDate || "";
        Amount = advance?.Amount || "";
        Advance_Type = advance?.Advance_Type || "";

        setFormData(prev => ({
            ...prev,
            ...headData,
        }));

        setLastTenderData(headData || {});
        setLastTenderDetails(detailData || []);
        setLastAdvanceData(AdvanceData || []);

        // const formattedAdvance = (Array.isArray(AdvanceData) ? AdvanceData : []).map(a => ({
        //     ...a,
        //     AdvanceDate: a.advdate || a.AdvanceDate,
        // }));

        // setPatti_Awak_AdvanceData(formattedAdvance);
    };


    // handle cancel get last record data and set to
    const handleCancel = async () => {
        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);

        try {
            const response = await axios.get(
                `${API_URL}/get-PattiEntrylast-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );
            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.last_Patti_head_data, data.last_Patti_details_data, data.last_Patti_Advance_data);
                setIsChecked(true);
                // unlockRecord();
            } else {
                console.error(
                    "Failed to fetch last data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    // handle back button to navigate to the dashboard page.
    const handleBack = () => {
        navigate("/PattiEntry-utility");
    };

    // Navigation Funtionality
    const handleFirstButtonClick = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-PattiEntryfirst-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );
            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.first_Patti_head_data, data.first_Patti_details_data, data.first_Patti_Advance_data);
            } else {
                console.error(
                    "Failed to fetch first tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleLastButtonClick = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-PattiEntrylast-navigation?Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );
            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.last_Patti_head_data, data.last_Patti_details_data, data.last_Patti_Advance_data);
            } else {
                console.error(
                    "Failed to fetch last tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleNextButtonClick = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-Pattientrynext-navigation?Company_Code=${companyCode}&currentDocNo=${formData.Doc_No}&Year_Code=${Year_Code}`
            );
            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.next_Patti_head_data, data.next_Patti_details_data, data.next_Patti_Advance_data);
            } else {
                console.error(
                    "Failed to fetch next tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handlePreviousButtonClick = async () => {
        try {
            const response = await axios.get(
                `${API_URL}/get-PattiEntryprevious-navigation?Company_Code=${companyCode}&currentDocNo=${formData.Doc_No}&Year_Code=${Year_Code}`
            );

            if (response.status === 200) {
                const data = response.data;
                NavigationSetFields(data.previous_Patti_head_data, data.previous_Patti_details_data, data.previous_Patti_Advance_data);
            } else {
                console.error(
                    "Failed to fetch previous tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        if (selectedRecord) {
            handlerecordDoubleClicked();
        }
        else if (navigatedRecord && !isNaN(navigatedRecord) && parseInt(navigatedRecord) > 0) {
            handleNavigateRecord();
        }
        else {
            handleAddOne();
        }
    }, [selectedRecord, navigatedRecord]);


    const handlerecordDoubleClicked = async () => {

        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(false);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);

        try {
            const response = await axios.get(
                `${API_URL}/PattiEntryByid?Id=${selectedRecord.Id}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );

            if (response.status === 200) {
                const data = response.data;

                const headData =
                    data.last_Patti_head_data || {};

                const detailData =
                    data.last_Patti_details_data || [];

                const advanceData =
                    data.last_Patti_Advance_data ||
                    data["last_Patti_Advance_data "] ||
                    [];


                NavigationSetFields(
                    headData,
                    detailData,
                    advanceData
                );

            } else {
                console.error("Failed to fetch data:", response.status);
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };


    // const handleNavigateRecord = async () => {
    //     setIsEditing(false);
    //     setIsEditMode(false);
    //     setAddOneButtonEnabled(true);
    //     setEditButtonEnabled(false);
    //     setDeleteButtonEnabled(true);
    //     setBackButtonEnabled(true);
    //     setSaveButtonEnabled(false);
    //     setCancelButtonEnabled(false);
    //     setCancelButtonClicked(true);
    //     try {
    //         const response = await axios.get(
    //             `${API_URL}/getPattiByDocNo?Doc_No=${navigatedRecord}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
    //         );
    //         if (response.status === 200) {
    //             const data = response.data;
    //             newId = data.last_Patti_head_data.Id;
    //             partyName = data.last_Patti_details_data[0].PattiAccName;
    //             partyCode = data.last_Patti_head_data.Ac_Code;
    //             billToName = data.last_Patti_details_data[0].billtoname;
    //             billToCode = data.last_Patti_head_data.Bill_To;
    //             gstrate = data.last_Patti_details_data[0].gstrate;
    //             gstRateCode = data.last_Patti_head_data.GstRateCode;
    //             itemName = data.last_Patti_details_data[0].System_Name_E;
    //             item_code = data.last_Patti_details_data[0].System_Code;
    //             Advance_No = data.last_Patti_Advance_data[0].Advance_No;
    //             AwakNo = data.last_Patti_Advance_data[0].AdvanceawakNo || "";
    //             AdvanceDate = data.last_Patti_Advance_data[0].advdate;
    //             Amount = data.last_Patti_Advance_data[0].Amount;
    //             Advance_Type = data.last_Patti_Advance_data[0].Advance_Type;
    //             setFormData((prevData) => ({
    //                 ...prevData,
    //                 ...data.last_Patti_head_data,
    //             }));
    //             // setAdvanceData(data.last_Patti_Advance_data || []);

    //             setLastTenderData(data.last_Patti_head_data || {});
    //             setLastTenderDetails(data.last_Patti_details_data || []);
    //             setLastAdvanceData(data.last_Patti_Advance_data || []);
    //         } else {
    //             console.error(
    //                 "Failed to fetch last tender data:",
    //                 response.status,
    //                 response.statusText
    //             );
    //         }
    //     } catch (error) {
    //         console.error("Error during API call:", error);
    //     }
    // };


    const handleNavigateRecord = async () => {
        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(false);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);

        try {
            const response = await axios.get(
                `${API_URL}/getPattiByDocNo?Doc_No=${navigatedRecord}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );

            if (response.status === 200) {
                const data = response.data;
                console.log("getPattiByDocNo response:", data); // <-- inspect shape once, then remove

                NavigationSetFields(
                    data.last_Patti_head_data,
                    data.last_Patti_details_data,
                    data.last_Patti_Advance_data
                );
            } else {
                console.error(
                    "Failed to fetch record data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleKeyDown = async (event) => {
        if (event.key === "Tab") {
            const changeNoValue = event.target.value;
            try {
                const response = await axios.get(
                    `${API_URL}/getPattiByDocNo?Doc_No=${changeNoValue}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
                );
                const data = response.data;
                newId = data.last_Patti_head_data.Id;
                partyName = data.last_Patti_details_data[0].PattiAccName;
                partyCode = data.last_Patti_head_data.Ac_Code;
                billToName = data.last_Patti_details_data[0].billtoname;
                billToCode = data.last_Patti_head_data.Bill_To;
                gstrate = data.last_Patti_details_data[0].gstrate;
                gstRateCode = data.last_Patti_head_data.GstRateCode;
                itemName = data.last_Patti_details_data[0].System_Name_E;
                item_code = data.last_Patti_details_data[0].System_Code;
                Advance_No = data.last_Patti_Advance_data[0].Advance_No;
                AwakNo = data.last_Patti_Advance_data[0].AdvanceawakNo;
                AdvanceDate = data.last_Patti_Advance_data[0].advdate;
                Amount = data.last_Patti_Advance_data[0].Amount;
                Advance_Type = data.last_Patti_Advance_data[0].Advance_Type;

                setFormData({
                    ...formData,
                    ...data.last_Patti_head_data,
                });
                // setPatti_Awak_AdvanceData(data.last_Patti_grade_data || []);

                setLastTenderData(data.last_Patti_head_data || {});
                setLastTenderDetails(data.last_Patti_details_data || []);
                setLastAdvanceData(data.last_Patti_Advance_data || []);
                setIsEditing(false);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
    };

    //-------------------------------------------- Detail Section Start ----------------------------------------------------
    useEffect(() => {
        if (selectedRecord) {
            setUsers(
                lastTenderDetails.map((detail) => ({
                    // item: detail.item,
                    Item_Code: detail.Item_Code,
                    item_Name: detail.System_Name_E,
                    rowaction: "Normal",
                    ic: detail.ic,
                    id: detail.PattidetailId,
                    PattidetailId: detail.PattidetailId,
                    Qty: detail.Qty,
                    Value: detail.Value,
                    Packing: detail.Packing,
                    container: detail.container,
                    Netwt: detail.PattiDetailNetwt,
                    netamt: detail.netamt,
                    AwakNo: detail.AwakNo,
                    Kattapatti: detail.Kattapatti,
                    AwakDetailId: detail.AwakDetailId,
                    bill_no: detail.bill_no,
                    tolaidar: detail.tolaidar,
                    bill_Date: detail.bill_Date,
                    detail_id: detail.detail_id,
                    gulsalebilldetailId: detail.gulsalebilldetailId

                }))
            );
        }
    }, [selectedRecord, lastTenderDetails]);

    useEffect(() => {
        const updatedUsers = lastTenderDetails.map((detail) => ({
            // item: detail.item,
            Item_Code: detail.Item_Code,
            item_Name: detail.System_Name_E,
            rowaction: "Normal",
            ic: detail.ic,
            id: detail.PattidetailId,
            PattidetailId: detail.PattidetailId,
            Qty: detail.Qty,
            Value: detail.Value,
            Packing: detail.Packing,
            container: detail.container,
            Netwt: detail.PattiDetailNetwt,
            netamt: detail.netamt,
            AwakNo: detail.AwakNo,
            bill_no: detail.bill_no,
            tolaidar: detail.tolaidar,
            bill_Date: detail.bill_Date,
            Kattapatti: detail.Kattapatti,
            AwakDetailId: detail.AwakDetailId,
            detail_id: detail.detail_id,
            gulsalebilldetailId: detail.gulsalebilldetailId
        }));
        setUsers(updatedUsers);
    }, [lastTenderDetails]);



    useEffect(() => {
        if (selectedRecord) {
            setAdvances(
                lastAdvanceData.map((advancedetail) => ({
                    rowaction: "Normal",
                    Advance_No: advancedetail.Advance_No,
                    Advance_Type: advancedetail.Advance_Type,
                    AdvanceDate: advancedetail.AdvanceDate,
                    PattiadvId: advancedetail.PattiadvId,
                    Amount: advancedetail.Amount,
                    AdvanceId: advancedetail.AdvanceId,
                    AwakNo: advancedetail.AwakNo,
                    advance_id: advancedetail.advance_id,
                }))
            );
        }
    }, [selectedRecord, lastAdvanceData]);

    useEffect(() => {
        const updatedadvanceUsers = lastAdvanceData.map((advancedetail) => ({
            rowaction: "Normal",
            Advance_No: advancedetail.Advance_No,
            Advance_Type: advancedetail.Advance_Type,
            AdvanceDate: advancedetail.AdvanceDate,
            PattiadvId: advancedetail.PattiadvId,
            Amount: advancedetail.Amount,
            AdvanceId: advancedetail.AdvanceId,
            AwakNo: advancedetail.AwakNo,
            advance_id: advancedetail.advance_id,
        }));
        setAdvances(updatedadvanceUsers);
    }, [lastAdvanceData]);






    const calculateDetails = (Awak_Qty, wt) => {
        const NetWt = Awak_Qty * wt;
        const roundedNetwt = Math.round(NetWt);
        return { Netwt: roundedNetwt };
    };

    const calculateTotalnetwt = (users) => {
        return users
            .filter((user) => user.rowaction !== "delete" && user.rowaction !== "DNU")
            .reduce((sum, user) => sum + parseFloat(user.Netwt || 0), 0);
    };

    const calculateTotalqty = (users) => {
        return users
            .filter((user) => user.rowaction !== "delete" && user.rowaction !== "DNU")
            .reduce((sum, user) => sum + parseFloat(user.Qty || 0), 0);
    };


    const calculateTotals = (users) => {

        return users.reduce(
            (totals, user) => {
                if (user.rowaction !== "delete" && user.rowaction !== "DNU") {
                    totals.totalamt += parseFloat(user.netamt || 0);
                    totals.totalQty += parseFloat(user.Qty || 0.00);
                    totals.totalNetwt += parseFloat(user.Netwt || 0);
                    totals.totalValue += parseFloat(user.Value || 0);
                    totals.totalContainer += parseFloat(user.container || 0);
                }
                return totals;
            },
            { totalamt: 0, totalQty: 0, totalNetwt: 0, totalValue: 0, totalContainer: 0, }
        );
    };

    const { totalamt, totalNetwt, totalQty, totalValue, totalContainer } = calculateTotals(users);

    const calculateAdvanceTotals = (advances) => {
        return advances.reduce(
            (totals, advance) => {
                if (advance.rowaction !== "delete" && advance.rowaction !== "DNU") {
                    totals.totaladv += parseFloat(advance.Amount || 0);
                }
                return totals;
            },
            { totaladv: 0, }
        );
    };

    const { totaladv } = calculateAdvanceTotals(advances);


    const handleChangeDetail = (event) => {
        const { name, value } = event.target;
        setFormDataDetail((prevDetail) => {
            const updatedDetail = {
                ...prevDetail,
                [name]: value,
            };

            const Awak_Qty_num = parseFloat(updatedDetail.Qty) || 0;
            const wt_num = parseFloat(updatedDetail.wt) || 0;

            const { Awak_Qty, wt } = updatedDetail;
            const { netwt } = calculateDetails(Awak_Qty_num, wt_num);


            return updatedDetail;
        });
    };

    const addUser = async () => {

        if (itemCode === "") {
            Swal.fire({
                icon: "warning",
                text: "Please Select Item.",
                confirmButtonColor: "#d33",
            });
            return false;
        }
        const maxDetailId =
            users.length > 0
                ? Math.max(...users.map((user) => user.detail_id)) + 1
                : 1;
        const newUser = {
            id: users.length > 0 ? Math.max(...users.map((user) => user.id)) + 1 : 1,
            Item_Code: itemCode,
            item_Name: item_Name,
            ic: itemCodeAccoid,
            ...formDataDetail,
            detail_id: maxDetailId,
            rowaction: "add",
        };

        const updatedUsers = [...users, newUser];
        setUsers(updatedUsers);

        const total = calculateTotals(updatedUsers);
        setFormData(prev => ({
            ...prev,
            netQty: total.totalQty,
            netwt: total.totalNetwt,
        }));

    };


    const addadvanceUser = async () => {
        const maxDetailId =
            advances.length > 0
                ? Math.max(...advances.map((advance) => advance.advance_id)) + 1
                : 1;
        const newUser = {
            id: advances.length > 0 ? Math.max(...advances.map((advance) => advance.id)) + 1 : 1,
            ...formDataAdvance,
            advance_id: maxDetailId,
            rowaction: "add",
        };

        const updatedUsers = [...advances, newUser];
        setAdvances(updatedUsers);

        const total = calculateAdvanceTotals(updatedUsers);
        setFormData(prev => ({
            ...prev,
            Advances: total.totaladv,
        }));

    };

    const updateUser = async () => {
        const updatedUsers = users.map((user) => {
            if (user.id === selectedUser.id) {
                const updatedRowaction =
                    user.rowaction === "Normal" ? "update" : user.rowaction;
                return {
                    ...user,
                    Item_Code: itemCode,
                    item_Name: item_Name,
                    bags: formDataDetail.bags,
                    Qty: formDataDetail.Qty,
                    Value: formDataDetail.Value,
                    Netwt: formDataDetail.PattiDetailNetwt,
                    Packing: formDataDetail.Packing,
                    container: formDataDetail.container,
                    netamt: formDataDetail.netamt,
                    gulsalebilldetailId: formDataDetail.gulsalebilldetailId,
                    detail_id: user.detail_id,
                    ic: itemCodeAccoid,
                    rowaction: updatedRowaction,
                };
            } else {
                return user;
            }
        });

        setUsers(updatedUsers);

        const netTotal = calculateDetails(updateUser);

        const total = calculateTotals(updatedUsers);
        setFormData(prev => ({
            ...prev,
            netQty: total.totalQty,
            netwt: total.totalNetwt,
        }));

        closePopup();
    };


    const updateadvanceUser = async () => {
        const updatedUsers = advances.map((advance) => {
            if (advance.id === selectedAdvanceUser.id) {
                const updatedRowaction = advance.rowaction === "Normal" ? "update" : advance.rowaction;
                return {
                    ...advance,
                    Advance_No: formDataAdvance.Advance_No,
                    Advance_Type: formDataAdvance.Advance_Type,
                    AdvanceDate: formDataAdvance.AdvanceDate,
                    Amount: formDataAdvance.Amount,
                    AdvanceId: formDataAdvance.AdvanceId,
                    AwakNo: formDataAdvance.AwakNo,
                    Id: advance.Id,
                    advance_id: advance.advance_id,
                    rowaction: advance.rowaction === "Normal" ? "update" : advance.rowaction,
                };
            } else {
                return advance;
            }
        });

        setAdvances(updatedUsers);

        const total = calculateAdvanceTotals(updatedUsers);
        setFormData(prev => ({
            ...prev,
            Advances: total.totaladv,
        }));

        closePopupAdvance();
    };

    const deleteModeHandler = async (user) => {
        try {

            // const isUsed = await checkGulSalebillForDetailIdUsage(user.Id);

            // if (isUsed) {
            //     Swal.fire({
            //         icon: "error",
            //         title: "Cannot Delete",
            //         text: "This Doc No is already used in Gul Sale Bill. You cannot delete it.",
            //         confirmButtonColor: "#d33",
            //     });
            //     return;
            // }
            let updatedUsers;
            if (isEditMode && user.rowaction === "add") {
                setDeleteMode(true);
                setSelectedUser(user);
                updatedUsers = users.map((u) =>
                    u.id === user.id ? { ...u, rowaction: "DNU" } : u
                );
            } else if (isEditMode) {
                setDeleteMode(true);
                setSelectedUser(user);
                updatedUsers = users.map((u) =>
                    u.id === user.id ? { ...u, rowaction: "delete" } : u
                );
            } else {
                setDeleteMode(true);
                setSelectedUser(user);
                updatedUsers = users.map((u) =>
                    u.id === user.id ? { ...u, rowaction: "DNU" } : u
                );

                console.log("DELETE CHECK:", {
                    isEditMode,
                    rowaction: user.rowaction,
                    id: user.id
                });
            }
            setUsers(updatedUsers);
            setSelectedUser({});

            const total = calculateAdvanceTotals(updatedUsers);
            setFormData(prev => ({
                ...prev,
                Advances: total.totaladv,
            }));


        } catch (error) {
            console.error("Error during API call:", error);
            Swal.fire({
                title: "Error",
                text: `There was an error during the deletion: ${error.message}`,
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };


    const deleteadvanceModeHandler = async (advance) => {
        try {

            // const isUsed = await checkGulSalebillForDetailIdUsage(user.Id);

            // if (isUsed) {
            //     Swal.fire({
            //         icon: "error",
            //         title: "Cannot Delete",
            //         text: "This Doc No is already used in Gul Sale Bill. You cannot delete it.",
            //         confirmButtonColor: "#d33",
            //     });
            //     return;
            // }
            let updatedUsersAdvance;
            if (isEditMode && advance.rowaction === "add") {
                setDeleteModeAdvance(true);
                setSelectedAdvanceUser(advance);
                updatedUsersAdvance = advances.map((u) =>
                    u.id === advance.id ? { ...u, rowaction: "DNU" } : u
                );
            } else if (isEditMode) {
                setDeleteModeAdvance(true);
                setSelectedAdvanceUser(advance);
                updatedUsersAdvance = advances.map((u) =>
                    u.id === advance.id ? { ...u, rowaction: "delete" } : u
                );
            } else {
                setDeleteModeAdvance(true);
                setSelectedAdvanceUser(advance);
                updatedUsersAdvance = advances.map((u) =>
                    u.id === advance.id ? { ...u, rowaction: "DNU" } : u
                );
                console.log("DELETE CHECK:", {
                    isEditMode,
                    rowaction: advance.rowaction,
                    id: advance.id
                });

            }
            setAdvances(updatedUsersAdvance);
            setSelectedAdvanceUser({});

            // const netTotal = calculateDetails(updateUser);


            const total = calculateAdvanceTotals(updatedUsersAdvance);
            setFormData(prev => ({
                ...prev,
                Advances: total.totaladv,
            }));


        } catch (error) {
            console.error("Error during API call:", error);
            Swal.fire({
                title: "Error",
                text: `There was an error during the deletion: ${error.message}`,
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    const openDelete = async (user) => {
        setDeleteMode(true);
        setSelectedUser(user);
        let updatedUsers;
        if (isEditMode && user.rowaction === "delete") {
            updatedUsers = users.map((u) =>
                u.id === user.id ? { ...u, rowaction: "Normal" } : u
            );
        } else {
            updatedUsers = users.map((u) =>
                u.id === user.id ? { ...u, rowaction: "add" } : u
            );
        }
        setUsers(updatedUsers);
        setSelectedUser({});

        const netTotal = calculateDetails(updateUser);


        const total = calculateTotals(updatedUsers);
        setFormData(prev => ({
            ...prev,
            netQty: total.totalQty,
            netwt: total.totalNetwt,
        }));
    };

    const openadvanceDelete = async (advance) => {
        setDeleteModeAdvance(true);
        setSelectedAdvanceUser(advance);
        let updatedUsersAdvance;
        if (isEditMode && advance.rowaction === "delete") {
            updatedUsersAdvance = advances.map((u) =>
                u.id === advance.id ? { ...u, rowaction: "Normal" } : u
            );
        } else {
            updatedUsersAdvance = advances.map((u) =>
                u.id === advance.id ? { ...u, rowaction: "add" } : u
            );
        }
        setAdvances(updatedUsersAdvance);
        setSelectedAdvanceUser({});

        // const netTotal = calculateDetails(updateUser);


        const total = calculateAdvanceTotals(updatedUsersAdvance);
        setFormData(prev => ({
            ...prev,
            Advances: total.totaladv,
        }));
    };

    const openPopup = (mode) => {
        setPopupMode(mode);
        setShowPopup(true);
        if (mode === "add") {
            clearForm();
        }
    };



    const closePopup = () => {
        setShowPopup(false);
        setSelectedUser({});
        clearForm();
    };

    const closePopupAdvance = () => {
        setShowPopupForAdvance(false);
        setSelectedAdvanceUser({});
        clearFormAdvance();
    };


    const openAdvancePopup = (mode) => {
        setPopupAdvanceMode(mode);
        setShowPopupForAdvance(true);
        if (mode === "add") {
            clearFormAdvance();
        }
    };

    const clearForm = () => {
        setFormDataDetail({
            Qty: 0.0,
            Netwt: 0,
            netamt: 0.0,
            Value: 0.0,
            Packing: 0.0,
            container: 0.0,
            detail_id: 1,
        });
        setItemCode("");
        setItemName("");
    };


    const clearFormAdvance = () => {
        setFormDataAdvance({
            Advance_No: "",
            Advance_Type: 'A',
            Amount: 0.0,
            PId: 0,
            AdvanceId: 0,
            AwakNo: 0,
            advance_id: 1,
        });
    };

    const editUser = async (user) => {
        try {

            // const isUsed = await checkGulSalebillForDetailIdUsage(user.Id);

            // if (isUsed) {
            //     Swal.fire({
            //         icon: "error",
            //         title: "Cannot Delete",
            //         text: "This Detail Id is already used in Gul Sale Bill. You cannot Edit it.",
            //         confirmButtonColor: "#d33",
            //     });
            //     return;
            // }
            setSelectedUser(user);
            setItemCode(user.Item_Code);
            setItemName(user.item_Name);
            setFormDataDetail({
                Qty: user.Qty || 0.0,
                Netwt: user.Netwt || 0,
                Value: user.Value || 0.0,
                Packing: user.Packing || 0.0,
                container: user.container || 0.0,
                netamt: user.netamt || 0.0,
                gulsalebilldetailId: user.gulsalebilldetailId || 0,
                detail_id: user.detail_id,
            });
            openPopup("edit");
        } catch (error) {
            console.error("Error in editUser:", error);
            await Swal.fire({
                title: "Error",
                text: "An unexpected error occurred while editing the user.",
                icon: "error",
            });
        }
    };

    const editadvanceUser = async (advance) => {
        try {

            // const isUsed = await checkGulSalebillForDetailIdUsage(user.Id);

            // if (isUsed) {
            //     Swal.fire({
            //         icon: "error",
            //         title: "Cannot Delete",
            //         text: "This Detail Id is already used in Gul Sale Bill. You cannot Edit it.",
            //         confirmButtonColor: "#d33",
            //     });
            //     return;
            // }
            setSelectedAdvanceUser(advance);
            setFormDataAdvance({
                Advance_No: advance.Advance_No || 0,
                Advance_Type: advance.Advance_Type || "",
                AdvanceDate: advance.AdvanceDate || "",
                Amount: advance.Amount || 0.00,
                AdvanceId: advance.AdvanceId || 0,
                AwakNo: advance.AwakNo || 0,
                advance_id: advance.advance_id,
            });
            openAdvancePopup("edit");
        } catch (error) {
            console.error("Error in editUser:", error);
            await Swal.fire({
                title: "Error",
                text: "An unexpected error occurred while editing the user.",
                icon: "error",
            });
        }
    };

    const handleItemCode = (code, accoid, hsn, name, kgper) => {
        console.log("handleItemCode", kgper)
        setItemCode(code);
        setItemName(name);
        setItemCodeAccoid(accoid);
    };

    const handleTableData = (data) => {
        const kgPerKatta = data?.Selected_SystemMaster_data?.KgPerKatta;

        if (kgPerKatta !== undefined) {
            setFormDataDetail((prevDetail) => ({
                ...prevDetail,
                wt: kgPerKatta,
            }));
        }
    };




    // const handleFetchedAwakData = (data) => {
    //     const row = data?.all_data?.[0];
    //     if (row) {
    //         setFramer(row.Ac_code || "");
    //         setFormData(prev => ({
    //             ...prev,
    //             Awak_No: row.Doc_No,
    //             Awak_Id: row.Id,
    //             Ac_Code: row.Ac_code || "",
    //             // Narration: `Qty: ${row.AwakQty}`,
    //         }));
    //     }
    // };

    const handleFetchedAwakData = (data, helpMode) => {

        const row = data?.all_data?.[0];

        // ---------------- PATTI MODE ----------------
        if (helpMode === "PATTI") {


            // Keep farmer + head data update (first time only)
            if (row) {
                setFramer(row.Ac_code || "");

                setFormData(prev => ({
                    ...prev,
                    // Do NOT overwrite Awak_No / Awak_Id for multiple selection
                    Ac_Code: row.Ac_code || "",
                }));
            }

            // ---------- APPEND DETAIL ----------
            if (Array.isArray(data.DetailData)) {
                setAwakDetailRows(prev => {
                    const newRows = data.DetailData.filter(
                        d => !prev.some(p => p.Awak_Id === d.Awak_Id)
                    );
                    return [...prev, ...newRows];
                });
            }

            // ---------- APPEND ADVANCE ----------
            if (Array.isArray(data.AdvanceData)) {
                setAwakAdvanceRows(prev => {
                    const newRows = data.AdvanceData.filter(
                        a => !prev.some(p => p.Awak_Id === a.Awak_Id)
                    );
                    return [...prev, ...newRows];
                });
            }

            return;
        }

        // ---------------- OTHER MODES (OLD BEHAVIOR) ----------------
        if (row) {
            setFramer(row.Ac_code || "");
            setFormData(prev => ({
                ...prev,
                // Awak_No: row.Doc_No,
                // Awak_Id: row.Id,
                Ac_Code: row.Ac_code || "",
            }));
        }
    };

    const applyAwakData = ({ qryGulSaleBillHeadAndDetailData, Patti_Awak_AdvanceData }) => {

        // console.log("helpModeselectedDocNos", helpMode, selectedDocNos);

        // if (helpMode !== "PATTI") return;

        // if (!selectedDocNos || selectedDocNos.length === 0) {
        //     setUsers([]);
        //     setPatti_Awak_AdvanceData([]);
        //     setFormData(prev => ({
        //         ...prev,
        //         netexps: "0.00",
        //         Hamaliamt: "0.00",
        //         Tolai: "0.00",
        //         Advances: "0.00",
        //         Container: "0.00",
        //     }));
        //     return;
        // }

        try {
            setAwakChanged(true);

            let allDetailRows = [];
            let allAdvanceRows = [];

            let totalHamali = 0;
            let totalTolai = 0;
            let totalExpenses = 0;
            let totalAdvance = 0;
            let totalContainer = 0;
            let awakdate = "";

            // ---------- DETAILS ----------
            if (qryGulSaleBillHeadAndDetailData?.length) {

                qryGulSaleBillHeadAndDetailData.forEach(row => {
                    const hamali = parseFloat(row.hamalical) || 0;
                    const tolai = TolaiSaleRate === 'Y'
                        ? (parseFloat(row.Tolaical) || 0)
                        : 0;
                    const containerAmt = parseFloat(row.containerAmt) || 0;

                    if (row.Awakdate) {
                        awakdate = new Date(row.Awakdate).toISOString().split("T")[0];
                    }

                    totalHamali += hamali;
                    totalTolai += tolai;
                    totalExpenses += hamali + tolai;
                    totalContainer += containerAmt;
                });

                const detailRows = qryGulSaleBillHeadAndDetailData.map((row, index) => ({
                    id: `${row.Awak_No}-${row.PattidetailId || index}`,
                    rowaction: row.PattidetailId ? "update" : "add",
                    Item_Code: row.Item_Code || "",
                    ic: row.ic || "",
                    item_Name: row.System_Name_E || "",
                    Qty: Number(row.Quantity) || 0,
                    Netwt: Number(row.Net_weight) || 0,
                    Value: Number(row.Rate) || 0,
                    Packing: Number(row.Packing) || 0,
                    container: Number(row.containerAmt) || 0,
                    netamt: Number(row.Amount) || 0,
                    AwakNo: row.Awak_No,
                    AwakDetailId: row.awakdetailId || 0,
                    gulsalebill: row.salebillId || 0,
                    gulsalebilldetailId: row.salebilldetailId || 0,
                    CustomerCode: row.CustomerCode || row.Customer_Code || 0,
                    Kattapatti: row.KattaPatti || 0,
                    bill_no: row.doc_no || 0,
                    tolaidar: row.tolaidarName || "",
                    bill_Date: row.doc_date || "",
                    cc: row.cc || 0,
                    detail_id: index + 1,
                }));

                allDetailRows.push(...detailRows);
            }


            const advanceRows = Patti_Awak_AdvanceData.map((row, index) => ({
                id: `${row.Awak_No}-${row.PattiadvId || index}`,
                rowaction: row.PattiadvId ? "update" : "add",
                Advance_No: row.Doc_No,
                AdvanceDate: row.Doc_Date
                    ? new Date(row.Doc_Date).toISOString().split("T")[0]
                    : new Date().toISOString().split("T")[0],
                Advance_Type: row.Advance_Type || "A",
                Amount: parseFloat(row.Advance) || 0,
                AdvanceId: row.Id || 0,
                AwakNo: row.Awak_No,
                advance_id: index + 1
            }));

            allAdvanceRows.push(...advanceRows);


            // ---------- ADVANCES ----------
            //     if (Patti_Awak_AdvanceData?.length) {

            //     Patti_Awak_AdvanceData.forEach(item => {
            //         totalAdvance += parseFloat(item.Advance) || 0;
            //     });

            //     const advanceRows = Patti_Awak_AdvanceData.map(row => ({
            //         Advance_No: row.Doc_No,
            //         AdvanceDate: row.Doc_Date
            //             ? new Date(row.Doc_Date).toISOString().split("T")[0]
            //             : new Date().toISOString().split("T")[0],
            //         Advance_Type: row.Advance_Type || "A",
            //         Amount: parseFloat(row.Advance) || 0,
            //         AdvanceId: row.Id || 0,
            //         AwakNo: row.Awak_No,
            //     }));

            //     allAdvanceRows.push(...advanceRows);
            // }

            // ---------- SET STATE ONLY ONCE ----------
            setUsers(allDetailRows);
            setAdvances(allAdvanceRows)

            setFormData(prev => ({
                ...prev,
                netexps: totalExpenses.toFixed(2),
                Container: totalContainer.toFixed(2),
                Hamaliamt: totalHamali.toFixed(2),
                Tolai: totalTolai.toFixed(2),
                Advances: totalAdvance.toFixed(2),
                AwakDate: awakdate,
            }));

            // setPatti_Awak_AdvanceData(allAdvanceRows);

        } catch (error) {
            console.error("Error in handleAwakcode:", error);
        }
    };





    // const handleAwakcode = async ({ helpMode, selectedDocNos }) => {

    //     console.log("helpModeselectedDocNos", helpMode, selectedDocNos)
    //     if (helpMode !== "PATTI") return;

    //     if (!selectedDocNos || selectedDocNos.length === 0) {
    //         setUsers([]);
    //         setPatti_Awak_AdvanceData([]);
    //         setFormData(prev => ({
    //             ...prev,
    //             netexps: "0.00",
    //             Hamaliamt: "0.00",
    //             Tolai: "0.00",
    //             Advances: "0.00",
    //             Container: "0.00",
    //         }));
    //         return;
    //     }

    //     try {
    //         setAwakChanged(true);

    //         let allDetailRows = [];
    //         let allAdvanceRows = [];


    //         let totalHamali = 0;
    //         let totalTolai = 0;
    //         let totalExpenses = 0;
    //         let totalAdvance = 0;
    //         let awakdate = "";

    //         for (const docNo of selectedDocNos) {
    //             const response = await axios.get(
    //                 `${API_URL}/PattiEntryallDataforAdvance`,
    //                 {
    //                     params: {
    //                         Company_Code: companyCode,
    //                         Year_Code,
    //                         Awak_No: docNo,
    //                     },
    //                 }
    //             );

    //             if (response.status === 200 && response.data) {
    //                 const {
    //                     qryGulSaleBillHeadAndDetailData,
    //                     Patti_Awak_AdvanceData
    //                 } = response.data;

    //                 // ---------- DETAILS ----------
    //                 if (qryGulSaleBillHeadAndDetailData?.length) {
    //                     qryGulSaleBillHeadAndDetailData.forEach(row => {
    //                         const hamali = parseFloat(row.hamalical || 0);
    //                         const tolai = parseFloat(row.Tolaical || 0);
    //                         awakdate = new Date(row.Awakdate).toISOString().split("T")[0];
    //                         totalHamali += hamali;
    //                         totalTolai += tolai;
    //                         totalExpenses += hamali + tolai;
    //                     });
    //                     const detailRows = qryGulSaleBillHeadAndDetailData.map((row, index) => ({
    //                         id: `${row.Awak_No}-${row.Id || index}`,
    //                         rowaction: row.Id ? "update" : "add",
    //                         Item_Code: row.Item_Code || "",
    //                         ic: row.ic || "",
    //                         item_Name: row.System_Name_E || "",
    //                         Qty: row.Quantity || 0,
    //                         Netwt: row.Net_weight || 0,
    //                         Value: row.Rate || 0,
    //                         Packing: row.Packing || 0,
    //                         container: row.containerAmt || 0,
    //                         netamt: row.Amount || 0,
    //                         AwakNo: row.Awak_No,
    //                         AwakDetailId: row.awakdetailId || 0,
    //                         gulsalebill: row.salebillId || 0,
    //                         gulsalebilldetailId: row.salebilldetailId || 0,
    //                         CustomerCode: row.CustomerCode || row.Customer_Code || 0,
    //                         Kattapatti: row.KattaPatti || 0,
    //                         bill_no: row.doc_no || 0,
    //                         tolaidar: row.tolaidarName || "",
    //                         bill_Date: row.doc_date || "",
    //                         cc: row.cc || 0,
    //                         detail_id: index + 1,
    //                     }));

    //                     allDetailRows.push(...detailRows);
    //                 }

    //                 // ---------- ADVANCES ----------
    //                 if (Patti_Awak_AdvanceData?.length) {

    //                     Patti_Awak_AdvanceData.forEach(item => {
    //                         totalAdvance += parseFloat(item.Advance || 0);
    //                     });

    //                     const advanceRows = Patti_Awak_AdvanceData.map(row => ({
    //                         Advance_No: row.Doc_No,
    //                         AdvanceDate: row.Doc_Date
    //                             ? new Date(row.Doc_Date).toISOString().split("T")[0]
    //                             : new Date().toISOString().split("T")[0],
    //                         Advance_Type: row.Advance_Type || "A",
    //                         Amount: parseFloat(row.Advance || 0),
    //                         AdvanceId: row.Id || 0,
    //                         AwakNo: row.Awak_No,
    //                     }));

    //                     allAdvanceRows.push(...advanceRows);
    //                 }

    //             }
    //         }

    //         //  SET STATE ONLY ONCE
    //         setUsers(allDetailRows);
    //         setFormData((prev) => ({
    //             ...prev,
    //             netexps: totalExpenses.toFixed(2),
    //             Container: totalContainer.toFixed(2),
    //             Hamaliamt: totalHamali.toFixed(2),
    //             Tolai: totalTolai.toFixed(2),
    //             Advances: totalAdvance.toFixed(2),
    //             AwakDate: awakdate,
    //         }));
    //         setPatti_Awak_AdvanceData(allAdvanceRows);

    //     } catch (error) {
    //         console.error("Error in handleAwakcode:", error);
    //     }
    // };

    // const handleAwakcode = async ({ helpMode, selectedDocNos }) => {
    //      console.log("helpModeselectedDocNos", helpMode, selectedDocNos)
    //     if (helpMode !== "PATTI") return;

    //     if (!selectedDocNos || selectedDocNos.length === 0) {
    //         setUsers([]);
    //         setPatti_Awak_AdvanceData([]);
    //         setFormData(prev => ({
    //             ...prev,
    //             netexps: "0.00",
    //             Hamaliamt: "0.00",
    //             Tolai: "0.00",
    //             Advances: "0.00",
    //             Container: "0.00",
    //         }));
    //         return;
    //     }
    //     if (!selectedDocNos || selectedDocNos.length === 0) return;

    //     try {
    //         let combinedResponse = [];

    //         for (const docNo of selectedDocNos) {
    //             const response = await axios.get(
    //                 `${process.env.REACT_APP_API}/PattiEntryallDataforAdvance`,
    //                 {
    //                     params: {
    //                         Company_Code: companyCode,
    //                         Year_Code,
    //                         Awak_No: docNo,
    //                     },
    //                 }
    //             );

    //             if (response.data) {
    //                 combinedResponse.push(response.data);
    //             }
    //         }

    //         setTempAdvanceData(combinedResponse);
    //         setPreviewData(combinedResponse);
    //         setShowAdvancePopup(true);
    //         setShowPreviewModal(true);

    //     } catch (error) {
    //         console.error("Error fetching advance data:", error);
    //     }
    // };
    const handleAwakcode = async ({ helpMode, selectedDocNos }) => {
        if (helpMode !== "PATTI") return;

        if (selectedDocNos.length < prevSelectedDocNos.length) {
            const uncheckedAwaks = prevSelectedDocNos.filter(
                awakNo => !selectedDocNos.includes(awakNo)
            );

            // REMOVE UNCHECKED AWAK DATA
            setAppliedAwakData(prevApplied => {
                const updatedApplied = prevApplied.filter(
                    block =>
                        !uncheckedAwaks.includes(
                            block.qryGulSaleBillHeadAndDetailData?.[0]?.Awak_No
                        )
                );

                // 🔹 RE-APPLY REMAINING DATA TO FORM
                applyAwakData({
                    qryGulSaleBillHeadAndDetailData: updatedApplied.flatMap(
                        d => d.qryGulSaleBillHeadAndDetailData || []
                    ),
                    Patti_Awak_AdvanceData: updatedApplied.flatMap(
                        d => d.Patti_Awak_AdvanceData || []
                    )
                });

                return updatedApplied;
            });
        }

        // 🔹 UPDATE PREVIOUS SELECTION
        setPrevSelectedDocNos(selectedDocNos);


        const newlyChecked = selectedDocNos.find(
            docNo => !prevSelectedDocNos.includes(docNo)
        );

        setPrevSelectedDocNos(selectedDocNos);

        if (!newlyChecked) return;

        const response = await axios.get(
            `${process.env.REACT_APP_API}/PattiEntryallDataforAdvance`,
            {
                params: {
                    Company_Code: companyCode,
                    Awak_No: newlyChecked,
                    Year_Code: Year_Code,
                },
            }
        );

        if (response.data) {
            // 🔍 PREVIEW ONLY
            setPreviewData([response.data]);
            setShowPreviewModal(true);
        }
    };






    const handleframer = async (
        code,
        accoid,
        Name,
        mobile,
        Gst_No,
        TDSApplicable,
        GSTStateCode,
        cityname,
        statename,
        whatsup_no,
    ) => {
        try {
            console.log("handleframer", whatsup_no);
            setFramer(code);


            const updatedFormData = {
                ...formData,
                Ac_Code: code,
                ac: accoid,
            };
            setFormData(updatedFormData);

        } catch (error) {
            console.error("Error in handleframer:", error);
        }
    };

    useEffect(() => {
        const totals = calculateTotals(users);
        const { totaladv } = calculateAdvanceTotals(advances);

        const expenses = Number(formData.netexps || 0);

        const pattiAmount =
            Number(totals.totalamt || 0) - totaladv - expenses;

        const patti =
            Number(totals.totalContainer || 0) + pattiAmount;

        setFormData(prev => ({
            ...prev,
            Patti_Amount: patti.toFixed(2),
            netAmt: Number(totals.totalamt || 0).toFixed(2),
            netQty: Number(totals.totalQty || 0).toFixed(2),
            netwt: Number(totals.totalNetwt || 0).toFixed(2),
            Container: Number(totals.totalContainer || 0).toFixed(2),
            Advances: totaladv.toFixed(2),
        }));

    }, [users, advances, formData.netexps]);


    const previewTotals = previewData?.reduce(
        (acc, block) => {
            block.qryGulSaleBillHeadAndDetailData?.forEach(row => {
                acc.qty += Number(row.Quantity) || 0;
                acc.rate += Number(row.Rate) || 0; // if you really want rate total
                acc.netwt += Number(row.Net_weight) || 0;
                acc.container += Number(row.containerAmt) || 0;
                acc.amount += Number(row.Amount) || 0;
            });
            return acc;
        },
        { qty: 0, rate: 0, netwt: 0, container: 0, amount: 0 }
    );

    const groupedPreview = previewData?.reduce((acc, block) => {
        block.qryGulSaleBillHeadAndDetailData?.forEach(row => {
            if (!acc[row.Awak_No]) acc[row.Awak_No] = [];
            acc[row.Awak_No].push(row);
        });
        return acc;
    }, {});

    const activeAwakNo = previewData?.length
        ? previewData[previewData.length - 1]
            ?.qryGulSaleBillHeadAndDetailData?.[0]?.Awak_No
        : null;


    const filteredGroupedPreview = activeAwakNo
        ? { [activeAwakNo]: groupedPreview?.[activeAwakNo] }
        : groupedPreview;

    //in the Api I Have Arrays Of Arrays so for Combining all Advance array in one I use FlatMap Here , with filter of Awak No 
    const activeAdvanceRows = previewData
        ?.flatMap(block => block.Patti_Awak_AdvanceData || [])
        ?.filter(row => row.Awak_No === activeAwakNo);

    const handleOkClick = () => {
        if (!previewData?.length) return;

        setAppliedAwakData(prev => {
            // prevent duplicate Awak
            const existingAwakNos = prev.map(
                p => p.qryGulSaleBillHeadAndDetailData?.[0]?.Awak_No
            );

            const newBlocks = previewData.filter(
                p => !existingAwakNos.includes(
                    p.qryGulSaleBillHeadAndDetailData?.[0]?.Awak_No
                )
            );

            const updatedApplied = [...prev, ...newBlocks];

            // 🔴 APPLY DATA TO FORM HERE
            applyAwakData({
                qryGulSaleBillHeadAndDetailData: updatedApplied.flatMap(
                    d => d.qryGulSaleBillHeadAndDetailData || []
                ),
                Patti_Awak_AdvanceData: updatedApplied.flatMap(
                    d => d.Patti_Awak_AdvanceData || []
                )
            });

            return updatedApplied;
        });

        // close popup
        setPreviewData(null);
        setShowPreviewModal(false);
    };


    const handleCloseModal = () => {
        setShowPreviewModal(false);
    };



    return (
        <>
            <UserAuditInfo
                createdBy={formData.Created_By}
                modifiedBy={formData.Modified_By}
                title={"Patti Entry"}
            />
            <ToastContainer autoClose={500} />
            <br></br>
            <ActionButtonGroup
                handleAddOne={handleAddOne}
                addOneButtonEnabled={addOneButtonEnabled}
                handleSaveOrUpdate={handleSaveOrUpdate}
                saveButtonEnabled={saveButtonEnabled}
                isEditMode={isEditMode}
                handleEdit={handleEdit}
                editButtonEnabled={editButtonEnabled}
                handleDelete={handleDelete}
                deleteButtonEnabled={deleteButtonEnabled}
                handleCancel={handleCancel}
                cancelButtonEnabled={cancelButtonEnabled}
                handleBack={handleBack}
                backButtonEnabled={backButtonEnabled}
                isDeleted={formData.IsDeleted === 0}
                permissions={permissions}
                component={
                    <div style={{ display: "flex" }}>
                        <PattiReport Doc_No={formData.Doc_No} disabledFeild={!addOneButtonEnabled} />
                        <PattiBatchPrintReport from_doc_no={formData.Doc_No} to_doc_no={formData.Doc_No} disabledFeild={!addOneButtonEnabled} />
                    </div>
                }
            />
            <NavigationButtons
                handleFirstButtonClick={handleFirstButtonClick}
                handlePreviousButtonClick={handlePreviousButtonClick}
                handleNextButtonClick={handleNextButtonClick}
                handleLastButtonClick={handleLastButtonClick}
                highlightedButton={highlightedButton}
                isEditing={isEditing}
            />

            <form onSubmit={handleSubmit}>
                <Grid container alignItems="center" spacing={1} mt={0.5}>
                    <Grid item xs={12} sm={1}>
                        <FormControl fullWidth>
                            <TextField
                                label="Change No"
                                variant="outlined"
                                name="changeNo"
                                autoComplete="off"
                                onKeyDown={handleKeyDown}
                                disabled={!addOneButtonEnabled}
                                fullWidth
                                size="small"
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={6} sm={1}>
                        <FormControl>
                            <TextField
                                label="Patti No"
                                variant="outlined"
                                name="Doc_No"
                                autoComplete="off"
                                value={formData.Doc_No}
                                onChange={handleChange}
                                disabled
                                fullWidth
                                size="small"
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={6} sm={1}>
                        <FormControl>
                            <TextField
                                // inputRef={inputRef}
                                type="date"
                                label="Date"
                                variant="outlined"
                                name="Doc_Date"
                                value={formData.Doc_Date}
                                onChange={handleChange}
                                disabled={!isEditing && addOneButtonEnabled}
                                inputRef={inputRef}
                                fullWidth
                                size="small"
                                InputLabelProps={{
                                    style: { fontSize: "14px" },
                                }}
                                InputProps={{
                                    style: { fontSize: "12px", height: "40px" },
                                }}
                            />
                        </FormControl>
                    </Grid>


                </Grid>

                <div className="SugarSaleBill-row" style={{ marginTop: "10px" }}>
                    <label htmlFor="Bill_From" className="SugarSaleBillLabel">
                        Credit A/C :
                    </label>
                    <div>
                        <div>
                            <AccountMasterHelp
                                onAcCodeClick={handleframer}
                                CategoryName={partyName}
                                CategoryCode={partyCode}
                                name="Ac_Code"
                                Ac_type={[]}
                                disabledFeild={!isEditing && addOneButtonEnabled}
                            />
                        </div>
                    </div>
                </div>

                <div className="SugarSaleBill-row" style={{ marginTop: "20px" }}>
                    <label htmlFor="Bill_From" className="SugarSaleBillLabel">
                        Awak No:
                    </label>
                    <div >
                        <div >
                            <AwakEntryhelp
                                helpMode="PATTI"
                                onAcCodeClick={handleAwakcode}
                                // Awak_No={formDataDetail.Awak_No}
                                // Doc_No={formData.Awak_No}
                                // DetailId={formDataDetail.awkid}
                                onFetchedData={handleFetchedAwakData}
                                Ac_type={[]}
                                name="Awak_No"
                                tabIndexHelp={0}
                                farmerCode={Number(framer)}
                                enableFetchData={true}
                                enableFarmerFilter={true}
                                disabledFeild={true}
                                resetSelectionTrigger={resetPattiSelection}
                                showPreviewModal={showPreviewModal}
                            />
                        </div>
                    </div>
                </div>

                <Modal
                    show={showPreviewModal}
                    onHide={() => setShowPreviewModal(false)}
                    centered
                    fullscreen="sm-down"
                    dialogClassName="max-w-[360px] mx-auto transition-all duration-300 ease-in-out z-[1060]"
                    backdropClassName="bg-black/70 z-[1055]"
                    contentClassName="rounded-xl shadow-2xl"
                >
                    <Modal.Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Modal.Title>Awak Sale Preview</Modal.Title>
                        <Button
                            style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: 'blue' }}
                            onClick={() => {
                                handleCloseModal();
                                setResetPattiSelection(prev => !prev);
                            }}
                        >
                            X
                        </Button>
                    </Modal.Header>

                    <Modal.Body>
                        <table className="table table-bordered table-sm">
                            <thead className="table-light">
                                <tr>
                                    <th>Awak No</th>
                                    <th>Item Name</th>
                                    <th>Doc No</th>
                                    <th>Date</th>
                                    <th>Qty</th>
                                    <th>Rate</th>
                                    <th>Net Wt</th>
                                    <th>Container Amt</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredGroupedPreview &&
                                    Object.entries(filteredGroupedPreview).map(([awakNo, rows], gIdx) => {


                                        // subtotal per Awak
                                        const subTotal = rows.reduce(
                                            (acc, r) => {
                                                acc.qty += Number(r.Quantity) || 0;
                                                acc.rate += Number(r.Rate) || 0;
                                                acc.netwt += Number(r.Net_weight) || 0;
                                                acc.container += Number(r.containerAmt) || 0;
                                                acc.amount += Number(r.Amount) || 0;
                                                return acc;
                                            },
                                            { qty: 0, rate: 0, netwt: 0, container: 0, amount: 0 }
                                        );

                                        return (
                                            <React.Fragment key={gIdx}>

                                                {/* 🔹 GROUP HEADER */}
                                                <tr style={{ background: "#e9ecef", fontWeight: "bold" }}>
                                                    <td colSpan={8}>Awak No : {awakNo}</td>
                                                </tr>

                                                {/* 🔹 ROWS */}
                                                {rows.map((row, idx) => (
                                                    <tr key={`${gIdx}-${idx}`}>
                                                        <td>{row.Awak_No}</td>
                                                        <td>{row.System_Name_E}</td>
                                                        <td>{row.doc_no}</td>
                                                        <td>{row.doc_date}</td>
                                                        <td className="text-end">{row.Quantity}</td>
                                                        <td className="text-end">{row.Rate}</td>
                                                        <td className="text-end">{row.Net_weight}</td>
                                                        <td className="text-end">{row.containerAmt}</td>
                                                        <td className="text-end">{row.Amount}</td>
                                                    </tr>
                                                ))}

                                                {/*  SUBTOTAL PER AWAK */}
                                                <tr style={{ background: "#f8f9fa", fontWeight: "bold" }}>
                                                    <td colSpan={3} className="text-end">Sub Total</td>
                                                    <td className="text-end">{subTotal.qty.toFixed(2)}</td>
                                                    <td className="text-end">{subTotal.rate.toFixed(2)}</td>
                                                    <td className="text-end">{subTotal.netwt.toFixed(2)}</td>
                                                    <td className="text-end">{subTotal.container.toFixed(2)}</td>
                                                    <td className="text-end">{subTotal.amount.toFixed(2)}</td>
                                                </tr>

                                            </React.Fragment>
                                        );
                                    })
                                }

                                {/*  GRAND TOTAL (UNCHANGED)
                                {previewTotals && (
                                    <tr style={{ backgroundColor: "#fff3cd", fontWeight: "bold" }}>
                                        <td colSpan={3} className="text-end">Grand Total</td>
                                        <td className="text-end">{previewTotals.qty.toFixed(2)}</td>
                                        <td className="text-end">{previewTotals.rate.toFixed(2)}</td>
                                        <td className="text-end">{previewTotals.netwt.toFixed(2)}</td>
                                        <td className="text-end">{previewTotals.container.toFixed(2)}</td>
                                        <td className="text-end">{previewTotals.amount.toFixed(2)}</td>
                                    </tr>
                                )} */}
                            </tbody>

                        </table>

                        {/* ================= ADVANCE TABLE ================= */}
                        {activeAdvanceRows?.length > 0 && (
                            <>
                                <div style={{ marginTop: "25px", fontWeight: "bold" }}>
                                    Advance Details (Awak No : {activeAwakNo})
                                </div>

                                <table className="table table-bordered table-sm mt-2">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Advance No</th>
                                            <th>Awak No</th>
                                            <th>Advance Date</th>
                                            <th className="text-end">Amount</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {activeAdvanceRows.map((row, idx) => (
                                            <tr key={idx}>
                                                <td>{row.Doc_No}</td>
                                                <td>{row.Awak_No}</td>
                                                <td>
                                                    {row.Doc_Date
                                                        ? new Date(row.Doc_Date).toISOString().split("T")[0]
                                                        : ""}
                                                </td>
                                                <td className="text-end">
                                                    {Number(row.Advance).toFixed(2)}
                                                </td>
                                            </tr>
                                        ))}

                                        {/* ---- Advance Total ---- */}
                                        <tr style={{ background: "#f8f9fa", fontWeight: "bold" }}>
                                            <td colSpan={3} className="text-end">Total</td>
                                            <td className="text-end">
                                                {activeAdvanceRows
                                                    .reduce((sum, r) => sum + (Number(r.Advance) || 0), 0)
                                                    .toFixed(2)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </>
                        )}

                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                setPreviewData(null);
                                setShowPreviewModal(false);

                                setResetPattiSelection(prev => !prev);
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="primary"
                            onClick={handleOkClick}
                            disabled={!previewData?.length}
                        >
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>



                {isLoading && (
                    <div className="loading-overlay">
                        <div className="spinner-container">
                            <SaveUpdateSpinner />
                        </div>
                    </div>
                )}

                <div style={{ marginTop: "85px" }}>
                    <AddButton
                        openPopup={openPopup}
                        isEditing={isEditing}
                        ref={addButtonRef}
                        setFocusToFirstField={setFocusToFirstField}
                    // disabled={isEditing}
                    />
                </div>

                {/*detail part popup functionality and Validation part Grid view */}
                <div className="">
                    {showPopup && (
                        <div
                            className="sugar-salebill-modal"
                            role="dialog"
                            style={{ display: "block" }}
                        >
                            <div className="sugar-salebill-modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="sugar-salebill-modal-header">
                                        <h5 className="sugar-salebill-modal-title">
                                            {selectedUser.id ? "Update Patti Entry" : "Add Patti Entry"}
                                        </h5>
                                        <button
                                            type="button"
                                            onClick={closePopup}
                                            aria-label="Close"
                                            style={{
                                                width: "40px",
                                                height: "45px",
                                                borderRadius: "4px",
                                            }}
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="sugar-salebill-body ">
                                        <form>
                                            <div
                                                className="SugarSaleBill-row"
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <label
                                                    htmlFor="Mill_Name"
                                                    className="SugarSaleBillLabel"
                                                >
                                                    Item Code :
                                                </label>
                                                <div>
                                                    <div>
                                                        <SystemHelpMaster
                                                            //   tableData={handleTableData}
                                                            onAcCodeClick={handleItemCode}
                                                            CategoryName={item_Name}
                                                            CategoryCode={itemCode}
                                                            SystemType="I"
                                                            name="Item_Code"
                                                            firstInputRef={firstInputRef}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <Grid container spacing={2} className="mt-3">
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Qty"
                                                        name="Qty"
                                                        value={formDataDetail.Qty}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Netwt"
                                                        name="Netwt"
                                                        value={formDataDetail.Netwt ?? ""}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={2} className="mt-3">
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Value"
                                                        name="Value"
                                                        value={formDataDetail.Value}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"

                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Packing"
                                                        name="Packing"
                                                        value={formDataDetail.Packing}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={2} className="mt-3">
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Net Amount"
                                                        name="netamt"
                                                        value={formDataDetail.netamt}
                                                        onChange={handleChangeDetail}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"

                                                    />
                                                </Grid>


                                            </Grid>
                                        </form>
                                    </div>

                                    <div className="modal-footer">
                                        {selectedUser.id ? (
                                            <DetailUpdateButton updateUser={updateUser} />
                                        ) : (
                                            <DetailAddButtom addUser={addUser} />
                                        )}
                                        <DetailCloseButton closePopup={closePopup} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div>
                        <TableContainer
                            component={Paper}
                            className="mt-2"
                            sx={{ width: "70%" }}
                        >
                            <Table aria-label="user table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={headerCellStyle}>Actions</TableCell>
                                        {/* <TableCell sx={headerCellStyle}>RowAction</TableCell> */}
                                        <TableCell sx={headerCellStyle}>ID</TableCell>
                                        <TableCell sx={headerCellStyle}>Awak No</TableCell>
                                        <TableCell sx={headerCellStyle}>Sale Bill No</TableCell>
                                        <TableCell sx={headerCellStyle}>KattaPatti No</TableCell>
                                        <TableCell sx={headerCellStyle}>Item</TableCell>
                                        <TableCell sx={headerCellStyle}>Item Name</TableCell>
                                        <TableCell sx={headerCellStyle}>Qty</TableCell>
                                        <TableCell sx={headerCellStyle}>NetWt</TableCell>
                                        <TableCell sx={headerCellStyle}>Value</TableCell>
                                        <TableCell sx={headerCellStyle}>Container</TableCell>
                                        <TableCell sx={headerCellStyle}>Net Amount</TableCell>
                                        {/* <TableCell sx={headerCellStyle}>Print</TableCell> */}
                                    </TableRow>
                                </TableHead>


                                <TableBody>
                                    {users.map((user, index) => (
                                        <TableRow key={user.id}>
                                            <TableCell sx={{ padding: "0px 1px" }}>
                                                {user.rowaction === "add" ||
                                                    user.rowaction === "update" ||
                                                    user.rowaction === "Normal" ? (
                                                    <>
                                                        <EditButton
                                                            editUser={editUser}
                                                            user={user}
                                                            isEditing={isEditing}
                                                            disabled
                                                        />
                                                        <DeleteButton
                                                            deleteModeHandler={deleteModeHandler}
                                                            user={user}
                                                            isEditing={isEditing}
                                                            disabled
                                                        />
                                                    </>
                                                ) : user.rowaction === "DNU" ||
                                                    user.rowaction === "delete" ? (
                                                    <OpenButton openDelete={openDelete} user={user} />
                                                ) : null}
                                            </TableCell>
                                            {/* <TableCell>{user.rowaction}</TableCell> */}
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {user.detail_id}
                                            </TableCell>

                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {user.AwakNo}
                                            </TableCell>
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {user.bill_no}
                                            </TableCell>
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {user.Kattapatti}
                                            </TableCell>
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {user.Item_Code}
                                            </TableCell>

                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {user.item_Name}
                                            </TableCell>
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {user.Qty}
                                            </TableCell>
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {user.Netwt}
                                            </TableCell>
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {user.Value}
                                            </TableCell>
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {user.container}
                                            </TableCell>
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {user.netamt}
                                            </TableCell>
                                            {/* <TableCell sx={{ padding: "0px 1px", textAlign: "right" }}>
                                                <GulSaleBillDetailReport
                                                    salebilldetailId={user.gulsalebilldetailId}  
                                                    disabledFeild={!addOneButtonEnabled}
                                                    rows={users}
                                                />
                                            </TableCell> */}

                                        </TableRow>
                                    ))}

                                    <TableRow>
                                        <TableCell
                                            colSpan={7}
                                            sx={{ padding: "0px 1px", fontWeight: "bold", textAlign: "right" }}
                                        >
                                            Total:
                                        </TableCell>
                                        <TableCell sx={{ padding: "0px 1px", fontWeight: "bold", textAlign: "center" }}>
                                            {totalQty.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ padding: "0px 1px", fontWeight: "bold", textAlign: "center" }}>
                                            {totalNetwt.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ padding: "0px 1px", fontWeight: "bold", textAlign: "center" }}>
                                            {totalValue.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ padding: "0px 1px", fontWeight: "bold", textAlign: "center" }}>
                                            {totalContainer.toFixed(2)}
                                        </TableCell>
                                        <TableCell sx={{ padding: "0px 1px", fontWeight: "bold", textAlign: "center" }}>
                                            {totalamt.toFixed(2)}
                                        </TableCell>

                                        {/* <TableCell colSpan={4}></TableCell> */}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>

                {/* <div style={{ marginTop: "85px" }}>
                    <AddButton
                        openPopup={openAdvancePopup}
                        isEditing={isEditing}
                        ref={addButtonRef}
                        setFocusToFirstField={setFocusToFirstField}
                    // disabled={isEditing}
                    />
                </div> */}

                <div className="">
                    {showPopupForAdvance && (
                        <div
                            className="sugar-salebill-modal"
                            role="dialog"
                            style={{ display: "block" }}
                        >
                            <div className="sugar-salebill-modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="sugar-salebill-modal-header">
                                        <h5 className="sugar-salebill-modal-title">
                                            {selectedAdvanceUser.id ? "Update Patti Entry" : "Add Patti Entry"}
                                        </h5>
                                        <button
                                            type="button"
                                            onClick={closePopupAdvance}
                                            aria-label="Close"
                                            style={{
                                                width: "40px",
                                                height: "45px",
                                                borderRadius: "4px",
                                            }}
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="sugar-salebill-body ">
                                        <form>


                                            <Grid container spacing={2} className="mt-3">
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Advance_No"
                                                        name="Advance_No"
                                                        value={formDataAdvance.Advance_No}
                                                        onChange={handleChange}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="AwakNo"
                                                        name="AwakNo"
                                                        value={formDataAdvance.AwakNo ?? ""}
                                                        onChange={handleChange}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={2} className="mt-3">
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        type="date"
                                                        label="AdvanceDate"
                                                        name="AdvanceDate"
                                                        value={formDataAdvance.AdvanceDate}
                                                        onChange={handleChange}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"

                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Advance_Type"
                                                        name="Advance_Type"
                                                        value={formDataAdvance.Advance_Type}
                                                        onChange={handleChange}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={2} className="mt-3">
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        label="Amount"
                                                        name="Amount"
                                                        value={formDataAdvance.Amount}
                                                        onChange={handleChange}
                                                        fullWidth
                                                        autoComplete="off"
                                                        variant="outlined"
                                                        size="small"

                                                    />
                                                </Grid>


                                            </Grid>
                                        </form>
                                    </div>

                                    <div className="modal-footer">
                                        {selectedAdvanceUser.id ? (
                                            <DetailUpdateButton updateUser={updateadvanceUser} />
                                        ) : (
                                            <DetailAddButtom addUser={addadvanceUser} />
                                        )}
                                        <DetailCloseButton closePopup={closePopupAdvance} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}


                    {/* New Table after Patti Amount */}
                    <div style={{ marginTop: "10px", marginBottom: "50px" }}>
                        <TableContainer component={Paper} sx={{
                            width: "40%",
                            maxHeight: 250, //  limit height for scroll
                            overflowY: "auto", //  vertical scroll
                            borderRadius: 2,
                            boxShadow: 2,
                        }}>
                            <Table aria-label="user table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={headerCellStyle}>Actions</TableCell>
                                        <TableCell sx={headerCellStyle}>Id</TableCell>
                                        <TableCell sx={headerCellStyle}> Advance No</TableCell>
                                        <TableCell sx={headerCellStyle}>Awak No</TableCell>
                                        <TableCell sx={headerCellStyle}>Advance Date</TableCell>
                                        <TableCell sx={headerCellStyle}>Advance Type</TableCell>
                                        <TableCell sx={headerCellStyle}>Amount</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {advances.map((advance, index) => (
                                        <TableRow key={advance.id}>
                                            <TableCell sx={{ padding: "0px 1px" }}>
                                                {advance.rowaction === "add" ||
                                                    advance.rowaction === "update" ||
                                                    advance.rowaction === "Normal" ? (
                                                    <>
                                                        <EditButton
                                                            editUser={editadvanceUser}
                                                            user={advance}
                                                            isEditing={isEditing}
                                                            disabled
                                                        />
                                                        <DeleteButton
                                                            deleteModeHandler={deleteadvanceModeHandler}
                                                            user={advance}
                                                            isEditing={isEditing}
                                                        />
                                                    </>
                                                ) : advance.rowaction === "DNU" ||
                                                    advance.rowaction === "delete" ? (
                                                    <OpenButton openDelete={openadvanceDelete} user={advance} />
                                                ) : null}
                                            </TableCell>
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {advance.advance_id}
                                            </TableCell>
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {advance.Advance_No}
                                            </TableCell>

                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {advance.AwakNo}
                                            </TableCell>


                                            {/* Advance Date */}
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {advance.AdvanceDate}
                                            </TableCell>
                                            {/* Amount */}
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {advance.Advance_Type}
                                            </TableCell>
                                            <TableCell
                                                sx={{ padding: "0px 1px", textAlign: "center" }}
                                            >
                                                {advance.Amount}
                                            </TableCell>

                                        </TableRow>
                                    ))}

                                    <TableRow>
                                        <TableCell
                                            colSpan={6}
                                            sx={{ padding: "0px 1px", fontWeight: "bold", textAlign: "right" }}
                                        >
                                            Total:
                                        </TableCell>
                                        <TableCell sx={{ padding: "0px 1px", fontWeight: "bold", textAlign: "center" }}>
                                            {totaladv.toFixed(2)}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>


                <div style={{ display: 'grid' }} >
                    <div>
                        <div className="SaleBill-row" >
                            <Grid container spacing={1} mt={-38} sx={{ textAlign: 'left' }}>


                                <Grid container spacing={1} justifyContent="flex-end" alignItems="center" >

                                    <Grid item xs={1}>
                                        <label className="SugarSaleBillLabel">Net Amount :</label>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            variant="outlined"
                                            name="netAmt"
                                            autoComplete="off"
                                            value={formData.netAmt}
                                            onChange={handleChange}
                                            disabled
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            error={!!formErrors.netAmt}
                                            helperText={formErrors.netAmt}
                                            size="small"
                                            inputProps={{
                                                sx: { textAlign: 'right' },
                                                inputMode: 'decimal',
                                                pattern: '[0-9]*[.,]?[0-9]+',
                                                onInput: validateNumericInput,
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    fontSize: '16px',
                                                    fontWeight: 'bold',
                                                    color: 'black',
                                                    backgroundColor: 'white',
                                                    opacity: 1,
                                                    '& .Mui-disabled': {
                                                        color: 'black',
                                                        WebkitTextFillColor: 'black',
                                                        opacity: 1,
                                                    },
                                                },
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={1} justifyContent="flex-end" alignItems="center" >

                                    <Grid item xs={1}>
                                        <label className="SugarSaleBillLabel">Advances :</label>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            variant="outlined"
                                            name="Advances"
                                            autoComplete="off"
                                            value={formData.Advances}
                                            onChange={handleChange}
                                            disabled
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            error={!!formErrors.Advances}
                                            helperText={formErrors.Advances}
                                            size="small"
                                            inputProps={{
                                                sx: { textAlign: 'right' },
                                                inputMode: 'decimal',
                                                pattern: '[0-9]*[.,]?[0-9]+',
                                                onInput: validateNumericInput,
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    fontSize: '16px',
                                                    fontWeight: 'bold',
                                                    color: 'black',
                                                    backgroundColor: 'white',
                                                    opacity: 1,
                                                    '& .Mui-disabled': {
                                                        color: 'black',
                                                        WebkitTextFillColor: 'black',
                                                        opacity: 1,
                                                    },
                                                },
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                                    <Grid item xs={1}>
                                        <label className="SugarSaleBillLabel">Hamali:</label>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            name="Hamaliamt"
                                            autoComplete="off"
                                            value={formData.Hamaliamt || 0.0}
                                            // onKeyDown={handleKeyDownCalculations}
                                            onChange={handleChange}
                                            disabled
                                            error={Boolean(formErrors.Hamaliamt)}
                                            helperText={formErrors.Hamaliamt || ''}
                                            size="small"
                                            inputProps={{
                                                sx: { textAlign: 'right' },
                                                inputMode: 'decimal',
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    fontSize: '16px',
                                                    fontWeight: 'bold',
                                                    color: 'black',
                                                    backgroundColor: 'white',
                                                    opacity: 1,
                                                    '& .Mui-disabled': {
                                                        color: 'black',
                                                        WebkitTextFillColor: 'black',
                                                        opacity: 1,
                                                    },
                                                },
                                            }}

                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                                    <Grid item xs={1}>
                                        <label className="SugarSaleBillLabel">Tolai:</label>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            name="Tolai"
                                            autoComplete="off"
                                            value={formData.Tolai || 0.0}
                                            // onKeyDown={handleKeyDownCalculations}
                                            onChange={handleChange}
                                            disabled
                                            error={Boolean(formErrors.Tolai)}
                                            helperText={formErrors.Tolai || ''}
                                            size="small"
                                            inputProps={{
                                                sx: { textAlign: 'right' },
                                                inputMode: 'decimal',
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    fontSize: '16px',
                                                    fontWeight: 'bold',
                                                    color: 'black',
                                                    backgroundColor: 'white',
                                                    opacity: 1,
                                                    '& .Mui-disabled': {
                                                        color: 'black',
                                                        WebkitTextFillColor: 'black',
                                                        opacity: 1,
                                                    },
                                                },
                                            }}

                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                                    <Grid item xs={1}>
                                        <label className="SugarSaleBillLabel">Container:</label>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            name="Container"
                                            autoComplete="off"
                                            value={formData.Container || 0.0}
                                            // onKeyDown={handleKeyDownCalculations}
                                            onChange={handleChange}
                                            disabled
                                            error={Boolean(formErrors.Container)}
                                            helperText={formErrors.Container || ''}
                                            size="small"
                                            inputProps={{
                                                sx: { textAlign: 'right' },
                                                inputMode: 'decimal',
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    fontSize: '16px',
                                                    fontWeight: 'bold',
                                                    color: 'black',
                                                    backgroundColor: 'white',
                                                    opacity: 1,
                                                    '& .Mui-disabled': {
                                                        color: 'black',
                                                        WebkitTextFillColor: 'black',
                                                        opacity: 1,
                                                    },
                                                },
                                            }}

                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                                    <Grid item xs={1}>
                                        <label className="SugarSaleBillLabel">Patti Amount :</label>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            name="Patti_Amount"
                                            value={formData.Patti_Amount}
                                            onChange={handleChange}
                                            disabled
                                            error={Boolean(formErrors.Patti_Amount)}
                                            helperText={formErrors.Patti_Amount || ''}
                                            size="small"
                                            inputProps={{
                                                sx: { textAlign: 'right' },
                                                inputMode: 'decimal',
                                                pattern: '[0-9]*[.,]?[0-9]+',
                                                onInput: validateNumericInput,
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    fontSize: '16px',
                                                    fontWeight: 'bold',
                                                    color: 'black',
                                                    backgroundColor: 'white',
                                                    opacity: 1,
                                                    '& .Mui-disabled': {
                                                        color: 'black',
                                                        WebkitTextFillColor: 'black',
                                                        opacity: 1,
                                                    },
                                                },
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>



            </form >
        </>
    );
};
export default PattiEntry;
